import { Component } from '@nicolas-riciotti/light2';

const DURATION_MS = 1600;

// easeOutExpo — fast start, gentle settle into the final value.
function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
}

export default class BlockNumbers extends Component {

    created() {
        this.stopped = false;
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
    }

    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail);
    }

    attached() {

        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);

        this.$counts = Array.from(this.querySelectorAll('[data-count-up]'));
        if (!this.$counts.length) return;

        this._played = false;

        if ('IntersectionObserver' in window) {
            this._io = new IntersectionObserver((entries) => {
                for (const e of entries) {
                    if (e.isIntersecting && !this._played) {
                        this._played = true;
                        this._io.disconnect();
                        this.runCountUp();
                        break;
                    }
                }
            }, { threshold: 0.3 });
            this._io.observe(this);
        } else {
            this.runCountUp();
        }
    }

    detached() {
        this._io?.disconnect();
        if (this._raf) cancelAnimationFrame(this._raf);
    }

    runCountUp() {
        const items = this.$counts.map((el) => {
            const target = parseFloat(el.getAttribute('data-count-target'));
            const display = el.getAttribute('data-count-display') || String(target);
            // Match formatting of the final value: decimal places + commas.
            const decimals = (display.split('.')[1] || '').length;
            const hasCommas = display.includes(',');
            return { el, target: isNaN(target) ? 0 : target, decimals, hasCommas };
        });

        const format = (value, item) => {
            let out = value.toFixed(item.decimals);
            if (item.hasCommas) {
                const [intPart, decPart] = out.split('.');
                const withCommas = Number(intPart).toLocaleString('en-US');
                out = decPart != null ? `${withCommas}.${decPart}` : withCommas;
            }
            return out;
        };

        const setFinalValues = () => {
            items.forEach((item) => {
                item.el.textContent =
                    item.el.getAttribute('data-count-display') ?? format(item.target, item);
            });
        };

        if (this.stopped) {
            setFinalValues();
            return;
        }

        const start = performance.now();

        const step = (now) => {
            if (this.stopped) {
                setFinalValues();
                return;
            }

            const t = Math.min(1, (now - start) / DURATION_MS);
            const eased = easeOutExpo(t);

            items.forEach((item) => {
                item.el.textContent = format(item.target * eased, item);
            });

            if (t < 1) {
                this._raf = requestAnimationFrame(step);
            } else {
                setFinalValues();
            }
        };

        this._raf = requestAnimationFrame(step);
    }

}

customElements.define('block-numbers', BlockNumbers);
